<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="960" persistent>
    <v-card>
      <v-card-title class="px-4 pt-4 gap-2"> Coach </v-card-title>
      <v-data-table
        class="roster-table"
        disable-sort
        disable-filtering
        disable-pagination
        hide-default-footer
        :headers="headers"
        :items="items"
      >
        <template #item.rosterHeadshot="props">
          <v-edit-dialog :return-value.sync="props.item.rosterHeadshot" large persistent @save="save" @cancel="cancel">
            <v-img
              height="48"
              width="48"
              :alt="props.item?.rosterHeadshotAltText || 'Coach Headshot'"
              :src="props.item?.rosterHeadshot || '/default-img.png'"
              class="rounded-sm"
            />
            <template v-slot:input>
              <div class="py-4">
                <!-- <label class="grey--text text--darken-1">Page Sponsor Image</label> -->
                <upload-image
                  :value="props.item?.rosterHeadshot"
                  height="200"
                  width="200"
                  :fileUrl="props.item.rosterHeadshot"
                  @input="items[props.index].rosterHeadshot = $event"
                  key="2"
                  class="mb-5 mt-2"
                />
                <!-- :client-id="program.clientId" -->
              </div>
            </template>
          </v-edit-dialog>
        </template>
        <template #item.firstName="props">
          <v-edit-dialog persistent :return-value.sync="props.item.firstName">
            <span v-if="props.item.firstName" :id="`${props.item.id}-0`">{{ props.item.firstName }}</span>
            <span v-else class="text--disabled" :id="`${props.item.id}-0`">&mdash;</span>
            <template v-slot:input>
              <div class="py-4">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="props.item.firstName"
                  single-line
                  @blur="triggerEnterKeyPressEvent($event.target.id)"
                  @keydown.tab.exact.prevent="handleTabPress($event.target.id, props.item.id, 0)"
                  @keydown.shift.tab.prevent="handleShiftTabPress($event.target.id, props.item.id, 0)"
                ></v-text-field>
              </div>
            </template>
          </v-edit-dialog>
        </template>
        <template #item.lastName="props">
          <v-edit-dialog persistent :return-value.sync="props.item.lastName">
            <span v-if="props.item.lastName" :id="`${props.item.id}-1`">{{ props.item.lastName }}</span>
            <span v-else class="text--disabled" :id="`${props.item.id}-1`">&mdash;</span>
            <template v-slot:input>
              <div class="py-4">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="props.item.lastName"
                  single-line
                  @blur="triggerEnterKeyPressEvent($event.target.id)"
                  @keydown.tab.exact.prevent="handleTabPress($event.target.id, props.item.id, 1)"
                  @keydown.shift.tab.prevent="handleShiftTabPress($event.target.id, props.item.id, 0)"
                ></v-text-field>
              </div>
            </template>
          </v-edit-dialog>
        </template>
        <template #item.title="props">
          <v-edit-dialog persistent :return-value.sync="props.item.title">
            <span v-if="props.item.title" :id="`${props.item.id}-2`">{{ props.item.title }}</span>
            <span v-else class="text--disabled" :id="`${props.item.id}-2`">&mdash;</span>
            <template v-slot:input>
              <div class="py-4">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="props.item.title"
                  single-line
                  @blur="triggerEnterKeyPressEvent($event.target.id)"
                  @keydown.tab.exact.prevent="handleTabPress($event.target.id, props.item.id, 2)"
                  @keydown.shift.tab.prevent="handleShiftTabPress($event.target.id, props.item.id, 0)"
                ></v-text-field>
              </div>
            </template>
          </v-edit-dialog>
        </template>
        <template #item.bio="props">
          <v-edit-dialog large :return-value.sync="props.item.bio">
            <v-btn icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <template v-slot:input>
              <v-sheet class="pt-4" width="540">
                <html-text-editor :htmlContent="props.item.bio" />
              </v-sheet>
            </template>
          </v-edit-dialog>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn class="text-capitalize" depressed color="primary" @click="onSave">Done</v-btn>
        <v-btn class="text-capitalize" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
  import Vue, { PropType } from 'vue';
  import { CoachDetails } from '@/store/client/types';
  import { cloneDeep } from 'lodash-es';
  import UploadImage from '@/components/Ui/UploadImage.vue';
  import { mixins } from '../../mixin/mixins';
  import HtmlTextEditor from './HtmlTextEditor.vue';

  export default Vue.extend({
    name: 'PlayerEditModal',
    mixins: [mixins],
    components: {
      UploadImage,
      HtmlTextEditor,
    },
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      data: {
        type: Object as PropType<CoachDetails>,
        required: true,
      },
    },
    provide(): any {
      return {
        setHtml: this.setHtml,
      };
    },
    data() {
      return {
        headers: [
          { text: 'Image', value: 'rosterHeadshot' },
          { text: 'First Name', value: 'firstName' },
          { text: 'Last Name', value: 'lastName' },
          { text: 'Title', value: 'title' },
          { text: 'Bio', value: 'bio', cellClass: 'custom-cell' },
        ],
        items: [] as CoachDetails[],
      };
    },
    methods: {
      handleTabPress(idElement: any, id: number, order: number) {
        this.triggerEnterKeyPressEvent(idElement);
        /* eslint-disable */
        this.moveNextElementModal(this.items, id, order);
      },
      handleShiftTabPress(idElement: any, id: number, order: number) {
        this.triggerEnterKeyPressEvent(idElement);
        /* eslint-disable */
        this.movePreviousElementModal(this.items, id, order);
      },
      save() {
        // console.log('Dialog Saved');
      },
      cancel() {
        // console.log('Dialog cancel');
      },
      open() {
        // console.log('Dialog open');
      },
      setHtml(html: string) {
        this.items[0].bio = html;
      },
      onSave() {
        this.$emit('submit', this.items[0]);
        this.close();
      },
      close() {
        this.$emit('input', false);
      },
    },
    watch: {
      value(visible: boolean) {
        if (visible)
          this.items = [cloneDeep(this.data)].map((el) => {
            return {
              ...el,
              rosterHeadshot: el.rosterHeadshot || '',
            };
          });
      },
    },
  });
</script>
